'use client';
import React from 'react';
import { Box, Stack } from '@mui/material';
import { MarketingPageComponentProps } from '@services/launches/fetchLaunchMarketingContent';
import CustomImage from '@components/CustomImage';
import cn from './style.module.scss';

export default function WharfLocation(props: MarketingPageComponentProps) {
  return (
    <Stack component="section" className={cn.wharfLocationWrapper}>
      <Box className={cn.wharfLocationInner}>
        <Box className={cn.wharfLocationStory} id="wharfAreaID">
          <CustomImage
            src={props.images.ransome_wharf_location?.src || ''}
            alt={'BrookGreen Introduction Image'}
            width={768}
            height={768}
          />
        </Box>
      </Box>
    </Stack>
  );
}
